import React from "react";
import { Box, Heading, Notification, Text } from "@telia/teddy";
import "./CustomerSection.less";

interface Props {
    children: React.ReactNode;
    className?: string;
    description?: string;
    error?: string | null;
    heading: string;
}

const CustomerSection = ({ heading, description, className, error, children }: Props) => {
    return (
        <Box mb="300" pb="300" className={className}>
            <Heading as="h2" variant="title-100" mt="400">
                {heading}
            </Heading>
            {description && (
                <Text variant="additional-100" mt="100">
                    {description}
                </Text>
            )}
            {!!error && (
                <Notification type="tile" variant="error" className="error">
                    <Notification.Icon />
                    <Notification.Text>
                        <span dangerouslySetInnerHTML={{ __html: error }} />
                    </Notification.Text>
                </Notification>
            )}
            {children}
        </Box>
    );
};

export default CustomerSection;
